var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSbp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 36,
    viewBox: "0 0 54 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 53,
    height: 35,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 53,
    height: 35,
    rx: 5.5,
    stroke: "#D8E1EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8879_21650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 12.2344L20.6691 16.9423V19.8141L18.0031 24.5128L18 12.2344Z",
    fill: "#5B57A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2485 15.2284L30.7496 13.7157L35.8682 13.7109L28.2485 18.3172V15.2284Z",
    fill: "#D90751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2345 12.2065L28.2486 18.4397L25.5732 16.8175V7.5L28.2345 12.2065Z",
    fill: "#FAB718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8683 13.7116L30.7495 13.7163L28.2345 12.2065L25.5732 7.5L35.8683 13.7116Z",
    fill: "#ED6F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2486 24.5374V21.5132L25.5732 19.9219L25.5747 29.2486L28.2486 24.5374Z",
    fill: "#63B22F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7433 23.04L20.669 16.9423L18 12.2344L35.8573 23.0338L30.7433 23.04Z",
    fill: "#1487C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5747 29.2515L28.2483 24.5403L30.7431 23.0413L35.8571 23.0352L25.5747 29.2515Z",
    fill: "#017F36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0029 24.5135L25.5947 19.9242L23.0424 18.3789L20.669 19.8148L18.0029 24.5135Z",
    fill: "#984995"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8879_21650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 21.75,
    fill: "white",
    transform: "translate(18 7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbp);
export default __webpack_public_path__ + "static/media/SBP.c8e9f0e9a1f913d388d8b8fb9c554557.svg";
export { ForwardRef as ReactComponent };